import { assetTypes, assetsSection } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SectionHeading } from './shared/SectionHeading'

export function AssetsSection() {
  return (
    <section id="assets" className="relative py-20 md:py-28">
      <div className="shell">
        <SectionHeading
          eyebrow={assetsSection.eyebrow}
          title={assetsSection.title}
          intro={assetsSection.intro}
        />

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {assetTypes.map((asset, i) => (
            <Reveal key={asset.name} i={i} className="h-full">
              <article className="glass glass-rim glass-lift flex h-full flex-col p-5 md:p-6">
                <div className="mb-3 flex items-start justify-between gap-3">
                  <p className="micro">{asset.use}</p>
                  {asset.animated ? (
                    <span className="rounded-full border border-aqua/25 bg-aqua/10 px-2 py-0.5 font-mono text-[0.52rem] uppercase tracking-wider text-aqua">
                      animated
                    </span>
                  ) : null}
                </div>

                <h3 className="font-sans text-[1.1rem] font-semibold tracking-tight text-ink">
                  {asset.name}
                </h3>

                <p className="mt-2 flex-1 font-paragraph text-[0.85rem] leading-relaxed text-ink-dim">
                  {asset.body}
                </p>

                <p className="mt-5 border-t border-white/10 pt-3 font-mono text-[0.56rem] tracking-wide text-ink-mute">
                  {asset.formats}
                </p>
              </article>
            </Reveal>
          ))}

          {/* Fills the ninth cell so the 3-column grid stays rectangular */}
          <Reveal i={assetTypes.length} className="h-full">
            <article className="glass glass-rim flex h-full flex-col justify-center p-5 md:p-6">
              <p className="micro mb-2">Vectorisation</p>
              <p className="font-paragraph text-[0.85rem] leading-relaxed text-ink-dim">
                Raster output can be converted back to clean vector, so a generated PNG becomes an
                editable SVG rather than a finished picture.
              </p>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
